import React, { useEffect, useState } from 'react';
import { fetchAemPageContent, useEventListener, setConfigs } from '@msc-b2c/shared-utils';
import { AEMComponentRenderer } from '@msc-b2c/shared-components';
import { TransformedNode } from '@msc-b2c/interfaces/interfaces';
import { wrappers } from './wrappers';
import '@msc-b2c/base-style/src/lib/site/main.scss';
import { useDispatch } from 'react-redux';

export function App() {
  const [aemData, setAemData] = useState<TransformedNode>();

  const dispatch = useDispatch();

  useEventListener(window, 'author-content-update', () => {
    fetchAemPageContent(window.location.href).then((data) => {
      data && setAemData(data);
    });
  });

  useEffect(() => {
    fetchAemPageContent(window.location.href).then((data) => {
      data && setAemData(data);
      dispatch(setConfigs(data?.properties?.configs));
      return () => {};
    });
  }, [dispatch]);

  return (
    <AEMComponentRenderer
      aemDataRoot={aemData}
      wrappers={wrappers}
    />
  );
}

export default App;
